module.exports = function getResource (label) {
    let resources = {
        addPromoCode: 'Ajouter un code promotionnel',
        enterPromoRewards: 'Saisir la promo et les récompenses'
    };
    return resources[label];
};
